import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

export function useIndependentContractorBadgeRevamp() {
  return useCbhFlag(CbhFeatureFlag.INDEPENDENT_CONTRACTOR_BADGE_REVAMP, {
    defaultValue: {
      isEnabled: false,
    },
  });
}
